import React from 'react';
import { Button } from 'antd';
// import { useNavigate } from 'react-router-dom';

import { setToken } from '../../apis';

const LogoutModal = (props) => {
  // const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const { gModal, setGModal, name: adminName = 'Admin' } = props;

  const handleLogout = () => {
    setLoading(true);
    //
    setToken(null);

    ///
    setTimeout(() => {
      setLoading(false);
      setGModal((prev) => {
        return {
          ...prev,
          show: false,
        };
      });

      // 화면갱신
      window.location.reload();
    }, 1000);
  };

  const handleCancel = () => {
    setGModal((prev) => {
      return {
        ...prev,
        show: false,
      };
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '50rem',
        height: '21rem',
        background: '#FFFFFF',
        boxShadow: '0px 5px 20px rgba(75, 70, 92, 0.4)',
        borderRadius: 6,
      }}
    >
      <div
        style={{
          display: 'flex',
          height: '6.4rem',
          alignItems: 'center',
          // justifyContent: 'center',
          padding: '20px 24px',
          background: 'rgba(168, 170, 174, 0.16)',
          // font
          fontFamily: 'Public Sans',
          fontStyle: 'normal',
          fontWeight: 600,
          fontSize: '1.8rem',
          lineHeight: '2.4rem',
        }}
      >{`알림`}</div>
      <div
        style={{
          display: 'flex',
          height: '8.2rem',
          alignItems: 'center',
          justifyContent: 'center',
          // font
          fontFamily: 'Public Sans',
          fontStyle: 'normal',
          fontWeight: 400,
          fontSize: '1.5rem',
          lineHeight: '2.2rem',
        }}
      >{`Balane Fitter 최고관리자(${adminName}) 페이지에서 로그아웃 하시겠습니까?`}</div>
      <div
        style={{
          display: 'flex',
          // height: '3.2rem',
          alignItems: 'center',
          justifyContent: 'flex-end',
          padding: '1rem 1.2rem 0 0',
        }}
      >
        <Button
          type="primary"
          loading={loading}
          onClick={(e) => {
            handleLogout();
          }}
          danger
          style={{ marginRight: '1rem' }}
        >
          로그아웃
        </Button>
        <Button
          onClick={(e) => {
            handleCancel();
          }}
        >
          취소
        </Button>
      </div>
    </div>
  );
};

export default LogoutModal;
